import * as THREE from 'three';
/** Normalizes a raw IOrbConfig by applying defaults to all layers */
export function normalizeOrbConfig(config) {
    var _a, _b, _c, _d;
    const { defaultLayerSide = THREE.BackSide, defaultLayerScaleFactor = 0.05, 
    // NEW defaults
    defaultTransparent = false, defaultOpacity = 1, defaultDepthTest = true, defaultDepthWrite = true, defaultWireframe = false, textCanvasScale = 5, textFont = '48px Arial', textColor = 0x8e47ff, textOutlineColor = 0x191dfa, portalResolution = 512, portalShape = 'sphere' } = config;
    const normalizedActions = (_a = config.actions) === null || _a === void 0 ? void 0 : _a.map((action) => ({
        trigger: action.trigger,
        type: action.kind,
        options: action.options || {},
    }));
    //TODO set up text defaults
    const normalizedLayers = config.layers.map((layer, i) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return ({
            shape: (_a = layer.shape) !== null && _a !== void 0 ? _a : 'sphere',
            color: layer.color,
            // material defaults
            side: (_b = layer.side) !== null && _b !== void 0 ? _b : defaultLayerSide,
            transparent: (_c = layer.transparent) !== null && _c !== void 0 ? _c : defaultTransparent,
            opacity: (_d = layer.opacity) !== null && _d !== void 0 ? _d : defaultOpacity,
            depthTest: (_e = layer.depthTest) !== null && _e !== void 0 ? _e : defaultDepthTest,
            depthWrite: (_f = layer.depthWrite) !== null && _f !== void 0 ? _f : defaultDepthWrite,
            wireframe: (_g = layer.wireframe) !== null && _g !== void 0 ? _g : defaultWireframe,
            // geometry params pass-through
            geometryParams: layer.geometryParams,
            //side: layer.side ?? defaultLayerSide,
            scaleFactor: (_h = layer.scaleFactor) !== null && _h !== void 0 ? _h : (i === 0 ? 1.0 : defaultLayerScaleFactor),
            rotationSpeed: layer.rotationSpeed,
            portalSurface: layer.portalSurface,
        });
    });
    if (!config.imageSpriteScale) {
        config.imageSpriteScale = config.imageSize ? config.imageSize * 0.39 : 100;
    }
    // ✅ Narrow string | EdgeProfile → EdgeProfile
    let defaultElasticProfile;
    if (typeof config.defaultEdgeProfile === 'string') {
        // keep only the name; OrbConnectionManager.resolveProfile will look the profile up by name
        defaultElasticProfile = { name: config.defaultEdgeProfile };
    }
    else if (config.defaultEdgeProfile) {
        defaultElasticProfile = config.defaultEdgeProfile;
    }
    else {
        // fallback elastic default
        defaultElasticProfile = {
            name: 'default_orb_elastic',
            style: { color: 0x2196f3, widthPx: 4, opacity: 1.0 },
            elastic: {
                enabled: true,
                rest: 'surface',
                stiffness: 3.0,
                damping: 1.5,
                maxForce: 2000,
                minSeparation: 5, // works with CM rest-length padding
            },
        };
    }
    //const normalizedText = config.
    // ✅ actually include these in the returned config
    const portalLayer = (_b = config.portalLayer) !== null && _b !== void 0 ? _b : 'inner';
    const portalWindowMode = (_c = config.portalWindowMode) !== null && _c !== void 0 ? _c : 'screenSilhouette';
    return Object.assign(Object.assign({}, config), { orbType: config.orbType, defaultLayerSide,
        defaultLayerScaleFactor,
        // NEW material defaults persisted
        defaultTransparent,
        defaultOpacity,
        defaultDepthTest,
        defaultDepthWrite,
        defaultWireframe,
        textCanvasScale,
        textFont,
        textColor,
        textOutlineColor, layers: normalizedLayers, portalResolution,
        portalShape,
        portalLayer,
        portalWindowMode, actions: normalizedActions, 
        // ensure both dict and default exist so resolveProfile can find them
        edgeProfiles: (_d = config.edgeProfiles) !== null && _d !== void 0 ? _d : {}, defaultEdgeProfile: defaultElasticProfile });
}
